'use strict';

var es2016 = require('./es2016.js');

var es7 = es2016;

module.exports = es7;
